
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.794 6.166l-1.122-3.74A1.988 1.988 0 0011.756 1H4.244c-.89 0-1.66.573-1.916 1.426l-1.122 3.74A2.001 2.001 0 000 8v4a1 1 0 001 1v1a1 1 0 001 1h1a1 1 0 001-1v-1h8v1a1 1 0 001 1h1a1 1 0 001-1v-1a1 1 0 001-1V8c0-.82-.497-1.526-1.206-1.834zM4.244 3h7.512l.9 3H3.344l.9-3zM4 10.5a1 1 0 110-2 1 1 0 010 2zm8 0a1 1 0 110-2 1 1 0 010 2z"}})])
          )
        }
      }
    